<template>
    <div class="container mt-3 ml-1 text-dark">
        <div class="modal fade" id="add_department" tabindex="-1" role="dialog" aria-labelledby="add_department_label" data-backdrop="static" data-keyboard="false" aria-hidden="true">
            <div class="modal-dialog" role="document">
                <div class="modal-content">
                    <div class="modal-header" style="border-bottom: 0px;">
                        <button type="button" class="close" aria-label="Close" data-dismiss="modal">
                            <i class='fas fa-times text-muted'></i>
                        </button>
                    </div>
                    <div class="modal-body container">
                        <div class="form-group">
                            <label for="department_name" class="font-weight-bold">Afdeling aanmaken</label>
                            <input type="text" class="form-control" id="department_name" placeholder="Naam">
                        </div>
                        <div class="form-group">
                            <label for="department_parent" class="font-weight-bold">Hoofdafdeling</label>
                            <Select2 id="department_parent"
                                v-if="departments.length > 0"
                                v-model="selected"
                                :options="departments"
                                :settings="{
                                    width: '100%',
                                    placeholder: 'Zoek afdeling',
                                }"
                                @change="selectedDepartment"
                            />
                        </div>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" @click="saveNewDepartment">Toevoegen</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import Select2 from 'vue3-select2-component';

    export default {
        components: {
            Select2,
        },
        props: {
            changedDepartments: Boolean,
        },
        data: function () {
            return {
                departments: [],
                selected: null,
            }
        },
        watch: {
            changedDepartments: {
                handler: function () {
                    this.getDepartments();
                    $('#department_name').val("");
                },
                deep: true,
            }
        },
        beforeMount() {
            this.getDepartments();
        },
        methods: {
            /**
             *
             * Get data
             *
             */
            getEmployees(departmentID) {
                $.ajax({
                    type : 'GET',
                    headers: {
                        'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
                    },
                    dataType: 'json',
                    url : `get-employees`,
                    data:{
                        id: departmentID,
                    },
                    success: this.changeShownUsers,
                });
            },
            getDepartments() {
                $.ajax({
                    type : 'GET',
                    headers: {
                        'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
                    },
                    dataType: 'json',
                    url : `get-departments`,
                    success: this.saveDepartments,
                });
            },
            /**
             * Callbacks
             */
            saveDepartments(event) {
                this.departments = [];
                event.departments.forEach((department) => {
                    this.departments.push({id: department.id, text: department.name})
                });

                this.departments.sort(this.compare);
            },
            callBackNewDepartment() {
                $('#add_department').modal('hide');
                $('#department_name').val("");
                this.getDepartments();
                this.selected = null;
                this.$emit('added-department');
            },
            /**
             *
             * Events
             *
             */
            saveNewDepartment() {
                $.ajax({
                    type : 'POST',
                    headers: {
                        'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
                    },
                    dataType: 'json',
                    url : `new-department`,
                    data:{
                        name: $('#department_name').val(),
                        parent_id: this.selected,
                    },
                    success: this.callBackNewDepartment,
                });
            },
            selectedDepartment(event) {
                this.selected = event;
            },
            /**
             *
             * Sorting
             *
             */
            compare(value1, value2) {
                if (value1.text < value2.text){
                    return -1;
                }
                if (value1.text > value2.text){
                    return 1;
                }
                return 0;
            },
        },
    }
</script>
